import { configureStore } from "@reduxjs/toolkit";
import applicationsTableReducer from "./slices/ApplicationPage/applicationsTableSlice";
import applicationsFiltersReducer from "./slices/ApplicationPage/applicationsFiltersSlice";
import admissionOfficeDocSliceReducer from "./slices/AdmissionOffice/admissionOfficeDocSlice";
import userOptionsSliceReducer from "./slices/UserOptions/userOptionsSlice";
import sideBarMenuSliceReducer from "./slices/SideBarMenu/SideBarMenuSlice";
import sideBarMenuSliceReducerOld from "./slices/SideBarMenuOld/SideBarMenuSliceOld";
import AODatabaseTableSliceReducer from "./slices/AdmissionOfficeDatabase/AODatabaseTableSlice";
import PreloyderSliceReducer from "./slices/Preloyder/PreloyderSlice";
import tasksTableReducer from "./slices/TasksPage/tasksTableSlice";
import tasksFiltersReducer from "./slices/TasksPage/tasksFiltersSlice";
import officeAccountingTableReducer from "./slices/OfficeAccountingPage/officeAccountingTableSlice";
import officeAccountingFiltersReducer from "./slices/OfficeAccountingPage/officeAccountingFiltersSlice";

export const store = configureStore({
  reducer: {
    applicationsTable: applicationsTableReducer,
    applicationsFilters: applicationsFiltersReducer,
    officeAccountingTable: officeAccountingTableReducer,
    officeAccountingFilters: officeAccountingFiltersReducer,
    admissionOfficeDoc: admissionOfficeDocSliceReducer,
    userOptions: userOptionsSliceReducer,
    sideBarMenu: sideBarMenuSliceReducer,
    sideBarMenuOld: sideBarMenuSliceReducerOld,
    AODatabaseTable: AODatabaseTableSliceReducer,
    Preloyder: PreloyderSliceReducer,
    tasksTable: tasksTableReducer,
    tasksFilters: tasksFiltersReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
